import { Injectable } from '@angular/core';
import {Headers, Http, RequestOptions} from '@angular/http';
import {environment} from '../../../../environments/environment';
import {CookieService} from 'ngx-cookie';
declare var DDP_ENV: any;
@Injectable({
  providedIn: 'root'
})
export class RoleServiceService {
  readonly baseURL = DDP_ENV.userUrl;

  constructor(private _http: Http, private cookieService: CookieService) { }

  getAllRoles() {
    console.log('Inside get Roles');
    return this._http.get(this.baseURL + '/user/role', this.buildHeaders());

  }

  getRolePermission(roleId) {
    console.log('Inside get one Roles Permission');
    return this._http.get(this.baseURL + '/user/role/' + roleId, this.buildHeaders());

  }

  getAllPermissions() {
    console.log('Inside get Roles');
    return this._http.get(this.baseURL + '/permission', this.buildHeaders());
  }

  /* Construct a common header */
  private buildHeaders(): any {
    const headers = new Headers({'Authorization': 'Bearer ' + this.cookieService.get('ecare_access_token')});
    return new RequestOptions({ headers: headers });
  }

}
